export const CLOSE_MODAL = "CLOSE_MODAL";
export const CONNECTION_LOST = "CONNECTION_LOST";
export const CONNECTION_RESTORED = "CONNECTION_RESTORED";
export const CURRENT_USER_RECEIVE = "CURRENT_USER_RECEIVE";
export const CURRENT_SUBSCRIPTION_RECEIVE = "CURRENT_SUBSCRIPTION_RECEIVE";
export const DOCUMENT_HEAD_TITLE_SET = "DOCUMENT_HEAD_TITLE_SET";

export const GRAPH_CUBE_META_REQUEST = "GRAPH_CUBE_META_REQUEST";
export const GRAPH_CUBE_META_REQUEST_SUCCESS =
  "GRAPH_CUBE_META_REQUEST_SUCCESS";
export const GRAPH_CUBE_META_REQUEST_FAILURE =
  "GRAPH_CUBE_META_REQUEST_FAILURE";
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_REQUEST_SUCCESS = "LOGIN_REQUEST_SUCCESS";
export const LOGIN_REQUEST_FAILURE = "LOGIN_REQUEST_FAILURE";
export const LOGIN_COMPLETE_NEW_PASSWORD_REQUEST =
  "LOGIN_COMPLETE_NEW_PASSWORD_REQUEST";
export const LOGIN_COMPLETE_NEW_PASSWORD_SUCCESS =
  "LOGIN_COMPLETE_NEW_PASSWORD_SUCCESS";
export const LOGIN_COMPLETE_NEW_PASSWORD_FAILURE =
  "LOGIN_COMPLETE_NEW_PASSWORD_FAILURE";
export const LOGIN_AUTH_VERIFY_USER_REQUEST = "LOGIN_AUTH_VERIFY_USER_REQUEST";
export const LOGIN_AUTH_VERIFY_USER_REQUEST_SUCCESS =
  "LOGIN_AUTH_VERIFY_USER_REQUEST_SUCCESS";
export const LOGIN_AUTH_VERIFY_USER_REQUEST_FAILURE =
  "LOGIN_AUTH_VERIFY_USER_REQUEST_FAILURE";
export const LOGIN_AUTH_VERIFY_USER_RESET = "LOGIN_AUTH_VERIFY_USER_RESET";
export const NOTICE_CREATE = "NOTICE_CREATE";
export const NOTICE_REMOVE = "NOTICE_REMOVE";
export const OPEN_MODAL = "OPEN_MODAL";
export const PREFERENCES_FETCH = "PREFERENCES_FETCH";
export const PREFERENCES_FETCH_FAILURE = "PREFERENCES_FETCH_FAILURE";
export const PREFERENCES_FETCH_SUCCESS = "PREFERENCES_FETCH_SUCCESS";
export const PREFERENCES_RECEIVE = "PREFERENCES_RECEIVE";
export const PREFERENCES_REMOVE = "PREFERENCES_REMOVE";
export const PREFERENCES_SAVE = "PREFERENCES_SAVE";
export const PREFERENCES_SAVE_FAILURE = "PREFERENCES_SAVE_FAILURE";
export const PREFERENCES_SAVE_SUCCESS = "PREFERENCES_SAVE_SUCCESS";
export const PREFERENCES_SET = "PREFERENCES_SET";
export const ROUTE_SET = "ROUTE_SET";

export const SET_CURRENT_DECK = "SET_CURRENT_DECK";
export const SIGNUP_CURRENT_FLOW_NAME_SET = "SIGNUP_CURRENT_FLOW_NAME_SET";
export const SIGNUP_PROGRESS_SAVE_STEP = "SIGNUP_PROGRESS_SAVE_STEP";
export const SIGNUP_PROGRESS_SUBMIT_STEP = "SIGNUP_PROGRESS_SUBMIT_STEP";
export const SECTION_SET = "SECTION_SET";
export const SET_DATE_RANGE = "SET_DATE_RANGE";

//export const ADD_DEPARTMENT_FILTER = 'ADD_DEPARTMENT_FILTER';
//export const SET_DEPARTMENT_FILTERS = 'SET_DEPARTMENT_FILTERS';
//export const REMOVE_DEPARTMENT_FILTER = 'REMOVE_DEPARTMENT_FILTER';

export const STARTUP_LOADED_SUCCESS = "STARTUP_LOADED_SUCCESS";
export const DELETE_DASHBOARD_LAYOUT_SUCCESS =
  "DELETE_DASHBOARD_LAYOUT_SUCCESS";
export const SAVE_DASHBOARD_LAYOUT_SUCCESS = "SAVE_DASHBOARD_LAYOUT_SUCCESS";
export const DASHBOARD_LAYOUTS_RECEIVE = "DASHBOARD_LAYOUTS_RECEIVE";
export const DASHBOARD_LAYOUTS_REQUEST = "DASHBOARD_LAYOUTS_REQUEST";
export const DASHBOARD_LAYOUTS_REQUEST_SUCCESS =
  "DASHBOARD_LAYOUTS_REQUEST_SUCCESS";
export const DASHBOARD_LAYOUTS_REQUEST_FAILURE =
  "DASHBOARD_LAYOUTS_REQUEST_FAILURE";
export const EDIT_DASHBOARD_LAYOUT = "EDIT_DASHBOARD_LAYOUT";
export const RESET_DASHBOARD_LAYOUT = "RESET_DASHBOARD_LAYOUT";

export const SWITCH_DASHBOARD_LAYOUT = "SWITCH_DASHBOARD_LAYOUT";

export const SET_IN_PROGRESS_OPERATION = "SET_IN_PROGRESS_OPERATION";
export const REQUEST_PROGRESS_OPERATION = "REQUEST_PROGRESS_OPERATION";
export const REQUEST_PROGRESS_OPERATION_SUCESS =
  "REQUEST_PROGRESS_OPERATION_SUCESS";

export const CREATE_OPERATION_SUCESS = "CREATE_OPERATION_SUCESS";
export const CREATE_OPERATION_FAILURE = "CREATE_OPERATION_FAILURE";
export const SET_OPERATION_LAST_RAN = "SET_OPERATION_LAST_RAN";
export const DASHBOARD_FORM_START = "DASHBOARD_FORM_START";

export const ADD_DASHBOARD_FILTER = "ADD_DASHBOARD_FILTER";
export const REMOVE_DASHBOARD_FILTER = "REMOVE_DASHBOARD_FILTER";
export const RESET_DASHBOARD_FILTERS = "RESET_DASHBOARD_FILTERS";
export const SET_DASHBOARD_FILTERS = "SET_DASHBOARD_FILTERS";
export const REPORT_BUILDER_GO_TO_STEP = "REPORT_BUILDER_GO_TO_STEP";
export const REPORT_BUILDER_GO_TO_NEXT_STEP = "REPORT_BUILDER_GO_TO_NEXT_STEP";

export const REPORT_BUILDER_START = "REPORT_BUILDER_START";
export const REPORT_BUILDER_STOP = "REPORT_BUILDER_STOP";
export const REPORTS_RECEIVE = "REPORTS_RECEIVE";
export const DELETE_REPORT_SUCCESS = "DELETE_REPORT_SUCCESS";
export const DELETE_REPORT_FAILURE = "DELETE_REPORT_FAILURE";

export const EDIT_REPORT = "EDIT_REPORT";
export const REPORT_EDITOR_RESET = "REPORT_EDITOR_RESET";
export const SAVE_REPORT = "SAVE_WIDGET";
export const SAVE_REPORT_FAILURE = "SAVE_WIDGET_FAILURE";
export const SAVE_REPORT_SUCCESS = "SAVE_REPORT_SUCCESS";
export const REPORTS_REQUEST = "REPORTS_REQUEST";
export const REPORTS_REQUEST_SUCCESS = "REPORTS_REQUEST_SUCCESS";
export const REPORT_RENAME_FORM_START = "REPORT_RENAME_FORM_START";

export const SET_SELECTED_LOCATIONS_FILTER = "SET_SELECTED_LOCATIONS_FILTER";
export const SET_LOCATIONS_FILTER_OPTIONS = "SET_LOCATIONS_FILTER_OPTIONS";
